import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["loadingVoiceOver"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { Spinner } from '../Spinner/Spinner';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';
import { StyledChipSpinner } from './ChipSpinner.styles';

/**
 * An internal spinner created for `AssistChip`. Applying the `aria-live` and `aria-atomic`
 * attributes here isn't to spec since this element is added dynamically. However,
 * for now, it works better in NVDA and Talkback than applying these attributes to
 * a wrapper component.
 *
 * @related ['Spinner']
 * @since 8.97.0
 */
export var ChipSpinner = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var loadingVoiceOver = _ref.loadingVoiceOver,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledChipSpinner, _extends({
    ref: forwardedRef
  }, rest), /*#__PURE__*/React.createElement(Spinner, {
    size: "xs"
  }), /*#__PURE__*/React.createElement("span", {
    "aria-live": "polite",
    "aria-atomic": "false"
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, loadingVoiceOver)));
});
ChipSpinner.displayName = 'ChipSpinner';
ChipSpinner.propTypes = {
  /**
   * The text that will be announced to screen readers when the chip changes to
   * its loading state. Defaults to "loading". Text is `VisuallyHidden`.
   *
   * Don't include the chip's label text in `loadingVoiceOver` because some assistive
   * technologies will, by default, read the label text after the `loadingVoiceOver` text.
   */
  loadingVoiceOver: PropTypes.string
};
ChipSpinner.defaultProps = {
  loadingVoiceOver: 'Loading'
};